<template>
    <div>
        <!-- Loading -->
        <b-overlay :show="form.busy">

            <!-- Form -->
            <form @submit.prevent="submit" novalidate="true">

                <!-- Field -->
                <b-form-group :label="__('objective.Name')">
                    <b-form-input
                        v-model="form.name"
                        :class="{ 'is-invalid': form.errors.has('name') }"
                    ></b-form-input>
                    <has-error :form="form" field="name"></has-error>
                </b-form-group>

                <div class="row">
                    <div class="col-sm-6">
                        <!-- Field -->
                        <b-form-group :label="__('objective.Type')">
                            <select v-model="form.fk_objective_model" class="form-control" :class="{ 'is-invalid': form.errors.has('fk_objective_model') }">
                                <option v-for="(item, key) in models" :key="key" :value="key">
                                    {{ item }}
                                </option>
                            </select>
                            <has-error :form="form" field="fk_objective_model"></has-error>
                        </b-form-group>
                    </div>
                    <div class="col-sm-6">
                        <!-- Field -->
                        <b-form-group :label="__('objective.Interval')">
                            <select v-model="form.fk_objective_period" class="form-control" :class="{ 'is-invalid': form.errors.has('fk_objective_period') }">
                                <option v-for="(item, key) in periods" :key="key" :value="key">
                                    {{ item }}
                                </option>
                            </select>
                            <has-error :form="form" field="fk_objective_period"></has-error>
                        </b-form-group>
                    </div>
                </div>

                <!-- Field -->
                <b-form-group :label="__('objective.Value')">

                    <b-input-group v-if="form.fk_objective_model !== '3'" append="%">
                        <b-form-input
                            v-model="form.value"
                            :class="{ 'is-invalid': form.errors.has('value') }"
                            type="number"
                        ></b-form-input>
                    </b-input-group>

                    <b-input-group v-if="form.fk_objective_model === '3'" :prepend="symbol">
                        <b-form-input
                            v-model="form.value"
                            :class="{ 'is-invalid': form.errors.has('value') }"
                            type="number"
                        ></b-form-input>
                    </b-input-group>

                    <has-error :form="form" field="value"></has-error>
                </b-form-group>

                <div class="row">
                    <div class="col-sm-6">
                        <!-- Field -->
                        <b-form-group :label="__('objective.Initial Date')">
                            <b-form-datepicker
                                v-model="form.start_date"
                                :class="{ 'is-invalid': form.errors.has('start_date') }"
                                :locale="locale"
                                placeholder="">
                            </b-form-datepicker>
                            <has-error :form="form" field="start_date"></has-error>
                        </b-form-group>
                    </div>
                    <div class="col-sm-6">
                        <!-- Field -->
                        <b-form-group :label="__('objective.Final Date')">
                            <b-form-datepicker
                                v-model="form.end_date"
                                :class="{ 'is-invalid': form.errors.has('end_date') }"
                                :locale="locale"
                                placeholder="">
                            </b-form-datepicker>
                            <has-error :form="form" field="end_date"></has-error>
                        </b-form-group>
                    </div>
                </div>

                <!-- Submit -->
                <b-button type="submit" variant="primary" :disabled="form.busy">
                    {{ __('objective.Update Target') }}
                </b-button>
            </form>
        </b-overlay>
    </div>
</template>

<script>
import { Form } from 'vform'

export default {
    props: ['objective', 'endpointUpdate', 'locale', 'currency', 'symbol', 'startDate', 'models', 'periods', 'notations'],
    data() {
        return {
            loading: false,
            form: new Form({
                name: this.objective.name,
                start_date: this.$moment(this.objective.start_date).format('YYYY-MM-DD'),
                end_date: this.$moment(this.objective.end_date).format('YYYY-MM-DD'),
                fk_objective_model: this.objective.fk_objective_model,
                fk_objective_period: this.objective.fk_objective_period,
                value: this.objective.value
            })
        }
    },
    methods: {
        submit() {
            this.form.put(this.endpointUpdate)
                .then(result => {
                    if (result.redirect) {
                        window.location = result.redirect
                    }
                })
        },
    }
}
</script>

<style scoped>

</style>
